<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-md-4">
            <h3>
              <span class="text-muted">Admin:</span>
              {{ admin.name }}
            </h3>
            <h6>
              <span class="text-muted">Criação:</span>
              {{ formatDate(admin.created_at) }}
            </h6>
            <h6>
              <span class="text-muted">Última alteração:</span>
              {{ formatDate(admin.updated_at) }}
            </h6>
          </div>
          <div class="col-md-8">
            <form v-on:submit="update" method="post">
              <div class="row">
                <WarningRequiredFields />
                <ErrorsMessages :errors="errors" />
                <div class="col-md-6">
                  <LabelRequiredField label="Nome" />
                  <input type="text" v-model="name" class="form-control" />
                </div>
                <div class="col-md-6">
                  <LabelRequiredField label="E-Mail" />
                  <input type="email" v-model="email" class="form-control" />
                </div>
                <div class="col-md-6">
                  <LabelRequiredField label="Perfil" />
                  <select v-model="profile_id" class="form-control">
                    <option
                      v-for="profile in profiles"
                      :key="profile.id"
                      :value="profile.id"
                    >
                      {{ profile.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3">
                  <LabelRequiredField label="Status" />
                  <select v-model="status" class="form-control">
                    <option value="1">Ativo</option>
                    <option value="0">Inativo</option>
                  </select>
                </div>
                <div class="col-md-12 d-flex justify-content-between">
                  <v-btn
                    type="button"
                    class="v-secondary"
                    v-on:click="handleModalChangePassword()"
                  >
                    <span class="fa fa-edit"></span> Alterar senha
                  </v-btn>
                  <v-btn
                    :disabled="loadingUpdate"
                    type="submit"
                    class="v-success"
                  >
                    <span class="fa fa-check"></span>
                    {{ loadingUpdate ? "Carregando" : "Salvar" }}
                  </v-btn>
                </div>
              </div>
            </form>
            <!-- Modal change password -->
            <b-modal id="bv-modalChangePassword" hide-footer>
              <template v-slot:modal-title>Alterar senha</template>
              <div class="d-block">
                <div class="container">
                  <form v-on:submit="updatePassword" method="post">
                    <div class="row">
                      <WarningRequiredFields />
                      <ErrorsMessages :errors="errors" />
                      <div class="col-md-12">
                        <LabelRequiredField label="Senha" />
                        <input
                          type="password"
                          v-model="password"
                          class="form-control"
                          autocomplete="off"
                        />
                      </div>
                      <div class="col-md-12">
                        <LabelRequiredField label="Confirma senha" />
                        <input
                          type="password"
                          v-model="confirm_password"
                          class="form-control"
                          autocomplete="off"
                        />
                      </div>
                      <div class="col-md-12 text-right">
                        <v-btn
                          :disabled="loadingUpdatePassword"
                          type="submit"
                          class="v-success"
                        >
                          <span class="fa fa-check"></span>
                          {{ loadingUpdatePassword ? "Carregando" : "Salvar" }}
                        </v-btn>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </b-modal>
            <!-- /Modal change password -->
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import api from "../services/api";
import toast from "../components/ToastNotification";
import { formatDate } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "Profile",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],
      admin: {},
      id: "",
      profile_id: "",
      profiles: [],
      loading: true,
      loadingUpdate: false,
      loadingUpdatePassword: false,
      name: "",
      email: "",
      status: "",
      password: "",
      confirm_password: "",
    };
  },
  created() {
    this.getAdmin();
    this.getProfiles();
  },
  methods: {
    formatDate,
    async getAdmin() {
      this.loading = true;

      this.permissions = adminData().permissions;

      this.id = adminData().admin.id;
      this.profile_id = adminData().admin.profile_id;

      const response = await api.get("/admin/get", {
        params: { id: adminData().admin.id },
      });

      const { admin } = response.data;

      this.admin = admin;
      this.name = admin.name;
      this.email = admin.email;
      this.status = admin.status;
      this.profile_id = admin.profile_id;
      this.loading = false;
    },
    async getProfiles() {
      const response = await api.get("/admin/profile/all");

      const { profiles } = response.data;

      this.profiles = profiles;
    },
    async update(event) {
      event.preventDefault();
      this.loadingUpdate = true;

      try {
        const {
          admin: { id },
          name,
          email,
          status,
          profile_id,
        } = this;

        let params = {
          id,
          name,
          email,
          status,
          profile_id,
        };

        const response = await api.put("/admin/update", params);
        const { error, errors, message } = response.data;
        if (!error) {
          this.getAdmin(id);
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async updatePassword(event) {
      try {
        event.preventDefault();

        this.loadingUpdatePassword = true;

        const { id, password, confirm_password } = this;

        let params = {
          id,
          password,
          confirm_password,
        };

        const response = await api.put("/admin/password/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("bv-modalChangePassword");
          this.password = "";
          this.confirm_password = "";
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }

        this.loadingUpdatePassword = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalChangePassword() {
      this.errors = [];
      this.$bvModal.show("bv-modalChangePassword");
    },
  },
};
</script>